export const BRAND = {
    PAYDOCK: 'paydock',
    KOVENA: 'kovena',
};
